import { normalize } from 'normalizr';

const normalizeResponse = (dispatch, actionType, actionParams, json, schema) => {
  const payload = normalize(json, schema);

  return payload;
};

export default (startAction, successAction, failureAction, actionPromise, params, schema) => (
  (dispatch, getState) => {
    dispatch(
      Object.assign({}, params, {
        type: startAction
      })
    );

    const state = getState();

    return actionPromise(state)
      .then(
        (successJson) => {
          const payload = schema
            ? normalizeResponse(dispatch, successAction, params, successJson, schema)
            : successJson;

          dispatch(
            Object.assign({}, params, {
              type: successAction,
              payload,
              errors: successJson && successJson.errors
            })
          );

          return Promise.resolve(payload);
        }
      )
      .catch(
        (errorJson) => {
          dispatch(
            Object.assign({}, params, {
              type: failureAction,
              payload: errorJson,
              errors: errorJson && errorJson.errors
            })
          );

          return Promise.reject(errorJson);
        }
      );
  }
);
